import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@material-ui/core';

export const DocumentationHtmlRoot = styled('div')(({ theme }) => ({
  '& img': {
    maxWidth: '100%',
    height: 'auto',
    display: 'block',
  },
  '& iframe': {
    maxWidth: '100%',
    border: 0,
  },
  '& .kg-card': {
    margin: '0 0 24px 0',
  },
  '& .kg-image-card img': {
    borderRadius: 6,
  },
  '& .kg-bookmark-card a': {
    color: theme.palette.primary.main,
  },
}));

export const DocumentationHtmlImage = styled('img')({
  maxWidth: '100%',
  height: 'auto',
  display: 'block',
  margin: '0 0 24px 0',
});

export const DocumentationHtmlFigure = styled('figure')({
  margin: '0 0 24px 0',
  '& img': {
    marginBottom: 8,
  },
});

export const DocumentationHtmlFigcaption = styled('figcaption')(({ theme }) => ({
  fontFamily: 'Open Sans',
  fontSize: 14,
  lineHeight: '22px',
  color: theme.palette.text.secondary,
}));

export const DocumentationHtmlBlockquote = styled('blockquote')(({ theme }) => ({
  margin: '0 0 24px 0',
  padding: '8px 16px',
  borderLeft: `4px solid ${theme.palette.primary.main}`,
  color: theme.palette.text.primary,
}));

export const DocumentationOrderedList = styled('ol')({
  marginBottom: 16,
  paddingLeft: 20,
});

export const DocumentationFeatureTitle = styled('h6')(({ theme }) => ({
  fontFamily: 'Red Hat Display',
  fontSize: 16,
  fontWeight: 700,
  color: theme.palette.primary.main,
  margin: '14px 0 2px 0',
  'h2 + &, h3 + &, h4 + &, h5 + &': {
    marginTop: 8,
  },
  '& + p': {
    fontFamily: 'Open Sans',
    fontSize: 14,
    lineHeight: '22px',
    marginBottom: 14,
  },
  '& + &': {
    marginTop: 14,
  },
}));

export const DocumentationFeatureLink = styled('a')({
  fontFamily: 'inherit',
  fontSize: 'inherit',
  fontWeight: 'inherit',
  lineHeight: 'inherit',
  color: 'inherit',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
});

export const DocumentationFeatureRouterLink = styled(RouterLink)({
  fontFamily: 'inherit',
  fontSize: 'inherit',
  fontWeight: 'inherit',
  lineHeight: 'inherit',
  color: 'inherit',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
});
